<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container">
        <div class="page-title">{{ $t('message.home.vipPrivileges') }}</div>
        <div v-loading="loading">
          <div class="rights-grid" v-if="list.length">
            <div class="right-card" v-for="item in list" :key="item.id">
              <div class="right-icon-wrap">
                <img v-if="item.rightIcon" :src="item.rightIcon" class="right-icon" alt="" />
                <div v-else class="right-icon-placeholder">★</div>
              </div>
              <div class="right-name">{{ item.rightName }}</div>
              <div class="right-desc">{{ item.rightDescription }}</div>
            </div>
          </div>
          <el-empty v-if="!list.length && !loading" :description="$t('message.home.noData')" />
        </div>
        <div class="go-vip-wrap">
          <el-button type="primary" size="large" @click="$router.push('/member/center')">
            {{ $t('message.home.subscribe') }} VIP
          </el-button>
        </div>
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import { listMemberRight } from "@/api/upms/member_center";

export default {
  name: "MemberRight",
  data() {
    return { loading: false, list: [] }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      listMemberRight({ pageNumber: 1, pageSize: 50 }).then(r => {
        this.list = r.data?.data || []
        this.loading = false
      }).catch(() => { this.loading = false })
    }
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #f5f5f5; min-height: calc(100vh - 120px); }
.app-container { width: 1200px; margin: 0 auto; padding: 30px 0; }
.page-title { font-size: 22px; font-weight: bold; margin-bottom: 24px; }
.rights-grid { display: flex; flex-wrap: wrap; gap: 16px; }
.right-card { background: #fff; border-radius: 8px; padding: 24px; width: 260px; text-align: center; }
.right-icon-wrap { margin-bottom: 12px; }
.right-icon { width: 60px; height: 60px; }
.right-icon-placeholder { font-size: 40px; color: #e6a23c; }
.right-name { font-size: 16px; font-weight: bold; color: #303133; margin-bottom: 8px; }
.right-desc { font-size: 13px; color: #909399; line-height: 1.6; }
.go-vip-wrap { margin-top: 30px; text-align: center; }
</style>
